export default "__VITE_ASSET__DO1TzVwK__"